<template>
  <div
    class="reconciliation-empty-state"
    :data-testid="dataTestId"
  >
    <div class="reconciliation-empty-state__icon-wrap" aria-hidden="true">
      <img
        src="/img/icons/fbc-icons/ReconciliationEmptyTable.svg"
        alt=""
        class="reconciliation-empty-state__icon"
        data-testid="reconciliation__empty-state-icon"
      />
    </div>
    <div class="reconciliation-empty-state__text-stack">
      <p
        class="reconciliation-empty-state__heading"
        data-testid="reconciliation__empty-state-heading"
      >
        {{ heading }}
      </p>
      <p
        class="reconciliation-empty-state__description"
        data-testid="reconciliation__empty-state-description"
      >
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReconciliationEmptyState',

  props: {
    dataTestId: {
      type: String,
      default: 'reconciliation__empty-state',
    },
  },

  computed: {
    heading() {
      return this.$constants.RECONCILIATION_TABLE.TEXT.EMPTY_STATE_HEADING;
    },

    description() {
      return this.$constants.RECONCILIATION_TABLE.TEXT.EMPTY_STATE_DESCRIPTION;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/reconciliation-empty-state';
</style>
